import React from 'react'
import { makeStyles } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import { useCognitoProvider } from '../../providers/CognitoContext';
import { useBusinessProvider } from '../../providers/BusinessContext';

const useStyles = makeStyles((theme) => ({
    dataTitle: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: 600,
        color: '#1a2e22',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        [theme.breakpoints.down('xs')]: {
            marginLeft: theme.spacing(0.5),
        },
    },
    label: {
        color: '#4f6b5c',
        fontWeight: 500,
        fontSize: theme.typography.pxToRem(12),
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 124, 90, 0.1)',
        color: '#007C5A',
        borderRadius: 20,
        padding: '3px 10px',
        fontSize: theme.typography.pxToRem(12),
        fontWeight: 700,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 220,
        [theme.breakpoints.down('sm')]: {
            maxWidth: 140,
        },
    },
    impersonateBadge: {
        backgroundColor: 'rgba(245, 158, 11, 0.12)',
        color: '#b45309',
    },
    elipsis: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        maxWidth: 160,
    },
}));

export default function HeaderInfo() {

    const classes = useStyles();
    const { state } = useCognitoProvider();
    const { state: businessState } = useBusinessProvider();

    return (
        <Typography className={classes.dataTitle} component="div" noWrap>
            {state.impersonated ? (
                <>
                    <span className={classes.label}>Gestionando:</span>
                    <span className={`${classes.badge} ${classes.impersonateBadge}`}>
                        {businessState.business}
                    </span>
                </>
            ) : (
                <>
                    <span className={classes.badge}>
                        {businessState.business}
                    </span>
                </>
            )}
        </Typography>
    );
}
